import type { TransformFunctions } from '@sitecore/common';

export const businessUnit = 'nl';
export const countryCode = 'GB';
export const label = 'eneco';
export const name = 'gb-eneco-main';
export const uuid = 'HLPed9';
export const transformFunctions: TransformFunctions = {};

/** Scopes Sanity page lookups to this container's own pages. `SANITY_SITE` overrides it. */
export const sanitySite = 'site-eneco-co-uk';